import { Component } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SwUpdate } from '@angular/service-worker';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AutocloseOverlaysService } from './services/autoclose-overlays.service';
import { I18ConfigService } from './services/shared/I18-config.service';
import { ActivatedRoute } from '@angular/router';
import { ConnectionService } from 'ng-connection-service';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: ['ion-toast.toast-translucent { opacity: 0.98; } #disabled{ filter: grayscale(1);pointer-events: none; }']
})
export class AppComponent {

  status = 'ONLINE';
  connected = true;
  internetToast: HTMLIonToastElement;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private swUpdates: SwUpdate,
    private toastController: ToastController,
    private router: Router,
    private autocloseOverlaysService: AutocloseOverlaysService,
    private connectionService: ConnectionService,
    private i18Config: I18ConfigService,
    private activatedRoute: ActivatedRoute
  ) {
    // Decide language on initial load
    let selectedLanguage = localStorage.getItem('lang');
    if (selectedLanguage && typeof selectedLanguage !== 'undefined') {
      this.i18Config.setLanguage(selectedLanguage);
    } else {
      this.i18Config.setLanguage(this.i18Config.getDefaultLanguage());
    }

    this.activatedRoute.queryParams
      .subscribe(params => {
        if(!localStorage.getItem('pid') || localStorage.getItem('pid') == 'undefined' ){
          localStorage.setItem("pid", this.activatedRoute.snapshot.queryParams['pid']);
          localStorage.setItem("key", "qscwdv1plmok");
        }
        if(localStorage.getItem("pid") == "asp" && !localStorage.getItem('selectedAirportCode') ){
          localStorage.setItem("selectedAirportCode", this.activatedRoute.snapshot.queryParams['airport']);
        }
        if(localStorage.getItem("pid") == "asp" && !localStorage.getItem('userId') ){
          localStorage.setItem("userId", this.activatedRoute.snapshot.queryParams['userid']);
        }
      }
    );

    this.initializeApp();

    // close all popovers on back navigation, if open.
    this.router.events.subscribe((event: any): void => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'xx-xxxxx-xx', {
          page_path: event.urlAfterRedirects,
        });
      }

      if (event instanceof NavigationStart) {
        this.status = this.connected ? 'ONLINE' : 'OFFLINE';
        if (event.navigationTrigger === 'popstate') {
          this.autocloseOverlaysService.trigger();
          // use translator here.
        }
      }
    });

    // trigger update notification on new build release.
    this.swUpdates.available.subscribe((event) => {
      this.showUpdateToast();
    });

    // for recognizing  internet connection
    this.connectionService.monitor().subscribe(isConnected => {
      if (!isConnected) {
        this.internetToast.present();
      } else {
        this.internetToast.dismiss();
        this.initInternetToast(); // reinstatiating toast here to be ready to present after loss of internet
      }
      this.connected = isConnected;
    });

    this.initInternetToast(); // instatiating toast object to pre-fetch the dependencies to avoid lazy load which will fail after loss of connection

  }

  initInternetToast() {
    this.toastController.create({
      header: 'Internet Connection Lost!',
      position: 'top',
      translucent: true,
      buttons: [
      ]
    }).then((response) => {
      this.internetToast = response;
    });
  }
  async showUpdateToast() {
    const toast = await this.toastController.create({
      header: '*New Update Available!',
      position: 'top',
      translucent: true,
      buttons: [
        {
          text: 'Update',
          handler: () => {
            this.swUpdates.activateUpdate().then(() => document.location.reload());
          }
        }, {
          icon: 'close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    toast.present();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
